// Codes de plans Yeati qui donnent accès au "Communication Pack Dashboard".
// On match sur plan.code (identifiant stable) plutôt que plan.name (label commercial).
// Inclut packcom (actuel) ET standard (post-rename via migration yeati-api 20260611130811)
// pour rester transition-safe pendant le déploiement du rename.
export const DASHBOARD_COMMUNICATION_PLAN_CODES = ["packcom", "standard"] as const;

export const isDashboardCommunicationPlan = (planCode: string | undefined | null): boolean =>
  !!planCode && (DASHBOARD_COMMUNICATION_PLAN_CODES as readonly string[]).includes(planCode);
